/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeCancelInvoiceRequest, serializeInvoiceDto, type CancelInvoiceRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/cancel
 */
export interface CancelRequestBuilder extends BaseRequestBuilder<CancelRequestBuilder> {
    /**
     * Withdraws an invoice that was never issued, moving it from Draft to Cancelled. Only a draft can be cancelled — once an invoice has been issued the equivalent action is to void it, which is the entry a customer's history should show. Cancelled is terminal: the invoice cannot be issued, paid or reopened afterwards, and it stops counting toward its order's invoiced quantities and totals. Cancelling an already-cancelled invoice is refused, so this call is not idempotent.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CancelInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Withdraws an invoice that was never issued, moving it from Draft to Cancelled. Only a draft can be cancelled — once an invoice has been issued the equivalent action is to void it, which is the entry a customer's history should show. Cancelled is terminal: the invoice cannot be issued, paid or reopened afterwards, and it stops counting toward its order's invoiced quantities and totals. Cancelling an already-cancelled invoice is refused, so this call is not idempotent.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CancelInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CancelRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/cancel";
/**
 * Metadata for all the requests in the request builder.
 */
export const CancelRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CancelRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCancelInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
